import { render, staticRenderFns } from "./UserReflection.vue?vue&type=template&id=48eb517b&scoped=true&"
import script from "./UserReflection.vue?vue&type=script&lang=js&"
export * from "./UserReflection.vue?vue&type=script&lang=js&"
import style0 from "./UserReflection.vue?vue&type=style&index=0&id=48eb517b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb517b",
  null
  
)

export default component.exports